
export default function () {

    return {
        id: null,
        name: '',
    };
}
